const { alpha, darken } = require("@mui/material");

const useStyles = (theme, colorMode) => ({
  containerColumnCreatedAt: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    height: "100%",
    justifyContent: "start",
    alignItems: "center",
  },
  textDate: {
    color: "text.primary",
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subTextDate: {
    color: "text.secondary",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  containerColumnPermissao: {
    display: "flex",
    flexWrap: "wrap",
    height: "100%",
    fontWeight: "bold",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  boxSearchAndFilter: {
    width: { xs: "100%", md: "100%" },
    flexWrap: "wrap",
    gap: { xs: 1, md: 2 },
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  paper: {
    padding: 2,
    gap: 2,
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    minWidth: "320px",
    borderRadius: "0px 5px 5px 5px",
  },
  searchInput: {
    width: { xs: "100%", md: "400px" },
  },
  iconVerified: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  dataGrid: {
    width: "100%",
    height: "100%",
    minHeight: 300,
    fontSize: 12,
    borderRadius: "7px",
    border: 0,
    backgroundColor: theme.palette.background.paper,
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.background.tab,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.background.tab}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.primary",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent",
      border: 0,
      borderTop: `1px solid ${theme.palette.background.tab}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper,
      border: 0,
      borderTop: `1px solid ${theme.palette.background.tab}`,
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "55px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": {
      backgroundColor: theme.palette.background.card,
    },
    "& .odd-row": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .blink-row": {
      animation: "bg-pulse 1.4s ease-in-out infinite",
    },
    "@keyframes bg-pulse": {
      "50%": {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
      },
      "100%": {
        backgroundColor: alpha(theme.palette.primary.dark, 0.2),
      },
    },
  },
  chipActionCreate: {
    color: theme.palette.success.main,
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    height: "25px",
  },
  chipActionEdit: {
    color: theme.palette.info.main,
    backgroundColor: alpha(theme.palette.info.main, 0.1),
    height: "25px",
  },
  chipActionDelete: {
    color: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.1),
    height: "25px",
  },
  chipActionUpsert: {
    color:
      colorMode === "light"
        ? darken(theme.palette.warning.main, 0.5)
        : theme.palette.warning.light,
    backgroundColor: alpha(theme.palette.warning.main, 0.1),
    height: "25px",
  },
  iconUserNotFound: {
    fill: theme.palette.text.disabled,
    width: "100px",
    height: "100px",
  },
  backgroundBox: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme.palette.background.textField,
    borderRadius: "5px",
    gap: 1.5,
    padding: "4px 4px 4px 8px",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
  },
  sizeGridItem: "auto",
  boxTitle: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
    width: "100%",
    flexDirection: "row",
    gap: 0.5,
  },
  buttonClearFilters: {
    height: "32px",
    color: "text.primary",
    width: "fit-content",
  },
});

export default useStyles;
